import { Model } from "@bit/planetadeleste.shopaholic-mc.base";

export default class Base extends Model {}
